import { useGetDataQuery } from 'common/commonRedux/getRTKApi/baseApi';
import { useSelector } from 'react-redux';

// Define the structure of the department data
interface Department {
  intDepartmentId: number;
  isActive: boolean;
  strDepartmentName: string;
}
export const useDepartment = (): {
  departments: Department[];
  refetchDepartments: any;
  deptFetching: boolean;
} => {
  const accountid = useSelector(
    (state: any) => state.auth?.profileData?.tokenData?.accountid
  );
  const {
    data: departments = [],
    refetch: refetchDepartments,
    isFetching,
  } = useGetDataQuery(
    { params: { accountid }, urlObjKey: 'GetDepartments' },
    { skip: !accountid }
  );
  // useEffect(() => {
  //     apiAction({
  //         urlObjKey: 'GetDepartments',
  //         method: 'GET',
  //         params: {
  //             accountId: accountid,
  //         },
  //         isToast: false,
  //         cb: (data: Department[]) => {
  //             setDepartment(data);
  //         },
  //         onError: (error: unknown) => {
  //             console.error(error);
  //         }
  //     });
  // }, []);
  return {
    departments,
    refetchDepartments,
    deptFetching: isFetching,
  };
};
